import { useAppSelector } from '@/store/hooks';
import { selectFeatureFlag } from '@/store/slices/feature-flags/selectors';
import { FeatureFlagsEnum } from '@/store/slices/feature-flags/types';
import { PATHNAMES } from '@/utils/pathnames';
import { getBaseAdminURL } from '@/utils/urls';

export const useHomepageLink = (Pathname?: string) => {
  const usePJDHomepage = useAppSelector(selectFeatureFlag(FeatureFlagsEnum.platform_port_admin_homepage));

  if (usePJDHomepage) {
    return Pathname || PATHNAMES.Admin.Projects;
  }

  return getBaseAdminURL();
};
